module.exports = {"label":"Cancelar plano","title":"Urbano pós pago","description":{"areYouSure":"Tem certeza que deseja cancelar seu plano?","advice":"A VeloeTag abaixo deixará de funcionar."},"disclaimer":"Fazendo o cancelamento, a VeloeTag acima vai parar de funcionar e você não vai mais ter acesso livre aos locais conveniados.","button":"Solicitar cancelamento"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/CancelPlan/data.json
// module id = 2151
// module chunks = 0